/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Viewing (Open House)
 */

import { getLongDateTimeText, getShortDateTimeText } from '../utils/dateTimeInfoText'
import { Bizo, autoclass } from './base'
import type { RawViewing, Viewing as ViewingType } from './viewing.types'

export const Viewing = autoclass<ViewingType, RawViewing>(
  'Viewing',
  class Viewing extends Bizo<ViewingType, RawViewing> {},
  {
    agentId: 'agent_id',
    beginOn: 'begin_on',
    createdOn: 'created_on',
    description: 'description',
    endOn: 'end_on',
    listingId: 'listing_id',
    modifiedOn: 'modified_on',
    viewingId: 'viewing_id',
    viewingType: 'viewing_type',
    shortText: (t: Viewing) => (timezone: Parameters<typeof getShortDateTimeText>[2]) =>
      getShortDateTimeText(t.beginOn, t.endOn, timezone),
    longText: (t: Viewing) => (timezone: Parameters<typeof getLongDateTimeText>[2]) =>
      getLongDateTimeText(t.beginOn, t.endOn, timezone),
  }
)
export type Viewing = ViewingType
